// Presentation only. These rooms never alter product artwork or POD metadata.
export const TRAVEL_MS = 2600;
export const REDUCED_TRAVEL_MS = 160;
export const PREVIEW_END = .27;
export const APPROACH_START = .48;
const ROOMS = [
  { x: 0, yaw: 0, kind: 'portal', eyeX: .16, eyeY: .28, previewFar: 7.2, previewLift: .30, tone: '#171b1f', light: '#fff9ea', power: 115, word: 'SCORPION' },
  { x: 4.2, yaw: -.38, kind: 'wall', eyeX: -2.7, eyeY: .15, aimX: -.18, previewFar: 8.0, previewLift: .20, previewX: -.4, tone: '#252a2e', light: '#ffffff', power: 140, word: 'SCORPION' },
  { x: -3.8, yaw: .34, kind: 'alcove', eyeX: 2.35, eyeY: .55, aimX: .2, previewFar: 7.0, previewLift: .35, previewX: .35, tone: '#20262a', light: '#f6f6e8', power: 120, word: 'JELLYFISH' },
  { x: 2.1, yaw: -.20, kind: 'dark', eyeX: -1.4, eyeY: -.25, aimX: -.12, previewFar: 8.4, previewLift: .18, previewX: -.25, tone: '#080b0e', light: '#ffffff', power: 85, word: 'SNAKE' },
  { x: -3.2, yaw: .30, kind: 'signal', eyeX: 2.7, eyeY: .45, aimX: .24, previewFar: 7.6, previewLift: .30, previewX: .35, tone: '#201d13', light: '#ffc400', power: 175, word: 'SNAKE' },
  { x: 3.1, yaw: -.28, kind: 'plinth', eyeX: -2.1, eyeY: 1.0, aimX: -.1, previewFar: 6.8, previewLift: .55, previewX: -.25, width: 4.3, height: 4.4, tone: '#272c30', light: '#fff8e6', power: 125, word: 'PUFFER' },
  { x: 0, yaw: .08, kind: 'finale', eyeX: 1.35, eyeY: .15, aimX: .1, previewFar: 8.6, previewLift: .25, previewX: .2, height: 5.2, tone: '#1b2024', light: '#ffc400', power: 165, word: 'SNAKE' },
];
const SLUGS = ['scorpion-chest-tee','scorpion-back-tee','jellyfish-hem-tee','snake-chest-tee','snake-back-tee','puffer-mug','snake-tumbler'];
export const clamp = (n, a, b) => Math.min(b, Math.max(a, n));
export const smooth = (t) => t * t * (3 - 2 * t);
export function travelPhase(progress) {
  const p=clamp(progress,0,1);
  if(p<PREVIEW_END) return { name:'reveal', progress:smooth(p/PREVIEW_END) };
  if(p<APPROACH_START) return { name:'hold', progress:1 };
  return { name:'approach', progress:smooth((p-APPROACH_START)/(1-APPROACH_START)) };
}
export function makeRooms(products) {
  return products.map((product, index) => {
    const known = SLUGS.indexOf(product.slug);
    const config = ROOMS[known < 0 ? index % ROOMS.length : known];
    const rawZ = Number(product.display_position?.z);
    const z = Number.isFinite(rawZ) ? rawZ * 1.8 : -14.4 * (index + 1);
    const word = known < 0 ? String(product.metadata?.mascot || product.name?.split(' ')[0] || config.word).toUpperCase() : config.word;
    return { width: 3.7, height: 5, ...config, word, z, y: 0, index, product };
  });
}
export function swipeDirection(start, end) {
  if (!start || !end) return 0;
  const dy = start.y - end.y, dx = start.x - end.x;
  return Math.abs(dy) >= 38 && Math.abs(dy) > Math.abs(dx) * 1.15 ? Math.sign(dy) : 0;
}
export function createWheelGate() {
  let last = -Infinity, sum = 0, fired = false;
  return (dy, now) => {
    if (now - last > 190) { sum = 0; fired = false; }
    last = now;
    if (fired) return 0;
    if (Math.sign(dy) !== Math.sign(sum)) sum = 0;
    sum += dy;
    if (Math.abs(sum) < 32) return 0;
    fired = true;
    return Math.sign(sum);
  };
}
